import { jsx as _jsx } from "react/jsx-runtime";
import { useMeasure } from "@uidotdev/usehooks";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useHydratedReducedMotion } from "../../hooks/useHydratedReducedMotion";
export default function ResizablePanel({ children, className, transitionKey }) {
    const [ref, { height }] = useMeasure();
    const reducedMotion = useHydratedReducedMotion();
    const stepMode = transitionKey !== undefined;
    // In step mode the tween is off by default and switched on for a short
    // window right after `transitionKey` changes, so only the transition itself
    // animates. In plain mode the tween is always on (legacy behaviour).
    const [tweening, setTweening] = useState(!stepMode);
    useEffect(() => {
        if (!stepMode || reducedMotion)
            return;
        setTweening(true);
        const t = setTimeout(() => setTweening(false), 250);
        return () => clearTimeout(t);
    }, [transitionKey, stepMode, reducedMotion]);
    return (_jsx(motion.div, { animate: { height: height || "auto" }, transition: tweening && !reducedMotion ? { duration: 0.2, ease: "easeInOut" } : { duration: 0 }, style: { width: "100%" }, className: "relative overflow-hidden", children: _jsx("div", { ref: ref, className: className, children: children }) }));
}
